import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  TableBody,
  Table,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  TableSortLabel,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import commonStyles from '../../styles';
import UnregisteredRecordTablesRow from './unregisteredRecordTablesRow';

const useStyles = makeStyles((theme) => ({
  table: {
  },
  cell: {
    padding: '8px',
    whiteSpace: 'break-spaces',
  },
  header: {
    borderBottom: 'solid 2px #C8C8C8',
  },
  headerTxt: {
    color: '#8C8C8C',
  },
  tableBody: {
    maxHeight: '150px',
    overflowY: 'auto',
  },
  icon: {
    '& .MuiTableSortLabel-icon': {
      fontSize: '12px',
    },
    '&.MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: theme.palette.primaryColor,
    },
  },
}));

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === b[orderBy]) {
    return 0;
  }
  if (a[orderBy] === null || a[orderBy] === undefined) {
    return 1;
  }
  if (b[orderBy] === null || b[orderBy] === undefined) {
    return -1;
  }
  return a[orderBy] < b[orderBy] ? 1 : -1;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function EnhancedTableHead(props) {
  const { cells, order, orderBy, onRequestSort } = props;
  const common = commonStyles();
  const classes = useStyles();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={classes.header}>
      <TableRow>
        {cells.map(c => (
          <TableCell
            key={c.id}
            style={c.style}
            className={classes.cell}
            sortDirection={orderBy === c.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === c.id}
              direction={orderBy === c.id ? order : 'asc'}
              onClick={createSortHandler(c.id)}
              className={classes.icon}
            >
              <Typography
                className={`${common.title4} ${classes.headerTxt}`}
              >
                {c.label}
              </Typography>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const allHeader = [
  { id: 'guidanceStartAt', label: '案内日時', style: { width: '120px' } },
  { id: 'customerName', label: '顧客名', style: { width: '150px' } },
  { id: 'guidanceStatusCode', label: '案内種別', style: { width: '150px' } },
  { id: 'guidanceGetUserName', label: '案内者', style: { width: '150px' } },
  { id: 'button', label: '', style: { width: '60px' } },
  { id: 'memo', label: 'メモ', style: { minWidth: '300px' } },
];

function UnregisteredRecordTable(props) {
  const {
    dataList,
    page,
    rowsPerPage,
    getCustomerFunction,
  } = props;
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('guidanceStartAt');
  const classes = useStyles();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <TableContainer>
      <Table className={classes.table}>
        <EnhancedTableHead
          cells={allHeader}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
        />
        <TableBody className={classes.tableBody}>
          {stableSort(dataList.data.unregists, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <UnregisteredRecordTablesRow
                  row={row}
                  key={row.guidanceId}
                  getCustomerFunction={getCustomerFunction}
                />
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default UnregisteredRecordTable;
